<div class="footer">
  <div class="footer-inner">
    <div class="flex-1">
      <div>
        <a routerLink="/">
          <img class="mb-5 line-height-3" src="/assets/imgs/Logo-alt.png">
        </a>
      </div>
      <div class="line-height-3" [innerHTML]="'layout.footer.tagline' | translate"></div>
    </div>
    <div class="footer-menus-container">
      <div class="footer-menu">
        <div>{{ 'layout.footer.products' | translate }}</div>
        <div>{{ 'layout.footer.clothes' | translate }}</div>
        <div>{{ 'layout.footer.decorations' | translate }}</div>
        <div class="flex align-items-center">
          <span class="flex-1 mr-2">{{ 'layout.footer.tattoos' | translate }}</span>
          <div class="pill pill-outline font-medium text-xs border-1 border-round-3xl">{{ 'layout.footer.new' | translate }}</div>
        </div>
      </div>
      <div class="footer-menu">
        <div>{{ 'layout.footer.info' | translate }}</div>
        <div>{{ 'layout.footer.how_it_works' | translate }}</div>
        <div>{{ 'layout.footer.get_inspired' | translate }}</div>
        <div [routerLink]="['blog']">{{ 'layout.footer.blog' | translate }}</div>
        <div>{{ 'layout.footer.faq' | translate }}</div>
        <div [routerLink]="['contact']">{{ 'layout.footer.contact' | translate }}</div>
      </div>
    </div>
    <div class="newsletter">
<!--      <div class="mb-3">{{ 'layout.footer.newsletter' | translate }}</div>-->
<!--      <app-newsletter></app-newsletter>-->
    </div>
  </div>
  <div class="footer-bottom border-top-1 border-white mt-4 xl:mt-7 pt-5 pb-3 line-height-3">
    <div class="footer-copyright">© {{ currentYear }} Pixie Pets. {{ 'layout.footer.rights' | translate }}</div>
    <div class="footer-legal">
      <a [routerLink]="['terms']" fragment="top" class="footer-link">{{ 'layout.footer.terms' | translate }}</a>
      <a [routerLink]="['privacy']" fragment="top" class="footer-link">{{ 'layout.footer.privacy' | translate }}</a>
      <a [routerLink]="['cookies']" fragment="top" class="footer-link">{{ 'layout.footer.cookies' | translate }}</a>
    </div>
  </div>
</div>
